import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Wraps a route so only authenticated users can access it.
 * Waits for the Supabase session check to complete before deciding
 * whether to redirect, preventing a flash of the login screen on refresh.
 */
export default function ProtectedRoute({ children }) {
  const { isAuthed, initialising } = useAuth();
  const location = useLocation();

  // Still checking localStorage for an existing session — render nothing.
  if (initialising) return null;

  if (!isAuthed) {
    // Preserve the intended destination so we can redirect back after login.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
